import api from '../../services/api';
import ResponseError from '../../types/response/ResponseError';
import { ResponseData } from '../../types/response/ResponseData';
import { PendingUser } from '../../types/users/PendingUser';

export const listPendingUsers = async (
    organizationId: string,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<PendingUser[]>) => void,
    searchFailed: (error: ResponseError) => void
) => {
    searchStarted();

    try {
        const response = await api.get<ResponseData<PendingUser[]>>(
            `organizations/${organizationId}/invitations`
        );

        searchSucceeded(response);
    } catch (error) {
        searchFailed(error as ResponseError);
    }
};

export const inviteUser = async (
    organizationId: string,
    inviteId: string,
    inviteStarted: () => void,
    inviteFailed: (error: ResponseError) => void,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<PendingUser[]>) => void,
    searchFailed: (error: ResponseError) => void
) => {
    inviteStarted();

    try {
        await api.post(`organizations/${organizationId}/invitations/${inviteId}/resend`, {});
        await listPendingUsers(organizationId, searchStarted, searchSucceeded, searchFailed);
    } catch (error) {
        inviteFailed(error as ResponseError);
    }
};

export const deletePendingUser = async (
    organizationId: string,
    inviteId: string,
    deleteStarted: () => void,
    deleteFailed: (error: ResponseError) => void,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<PendingUser[]>) => void,
    searchFailed: (error: ResponseError) => void
) => {
    deleteStarted();

    try {
        await api.del(`organizations/${organizationId}/invitations/${inviteId}`);
        await listPendingUsers(organizationId, searchStarted, searchSucceeded, searchFailed);
    } catch (error) {
        deleteFailed(error as ResponseError);
    }
};
